import { render } from "./residentsModalDetail.vue?vue&type=template&id=64e1781a&ts=true"
import script from "./residentsModalDetail.vue?vue&type=script&lang=ts"
export * from "./residentsModalDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__